import { Type, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import Types from '@philips-internal/oswald-ui-constants/lib/type';
import { Value } from '@philips-internal/oswald-ui-core';
import { BaseToastProps, ToastService as ToastS, ToastAPI} from '@philips-internal/oswald-ui-components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

interface Response {
  body: string;
  headers?: Record<string, Value>;
  status?: number;
  statusText?: string;
}

class ToastService {

  private static mainToast: ToastAPI;
  private static time = 5000;

  public static showMessage(toast: ToastAPI, type: Type, message: string, timeout: number = this.time): void {
    toast.setType(type);
    if(timeout > 0){
      toast.setTimeOut(timeout);
    }
    toast.setValue(message);
    toast.open();
  }

  public static setTarget(toast: ToastAPI): void {
    this.mainToast = toast;
  }

  public static safety(message: string, timeout: number = this.time): void {
    this.showToast(Types.SAFETY, message, timeout);
  }

  public static danger(message: string, timeout: number = this.time): void {
    this.showToast(Types.DANGER, message, timeout);
  }

  public static caution(message: string, timeout: number = this.time): void {
    this.showToast(Types.CAUTION, message, timeout);
  }

  public static showError(err: Response): void {

    const toast: BaseToastProps = {
      id: 'errorUnauthorized',
      dismissible: false,
      message: err.statusText ? err.statusText : MessageService.translate('newaccount.error.internal.server.error.try.again'),
      type: ToastType.BANNER,
      level: ToastLevel.ERROR,
      timeout: 4000
    };
    ToastS.open(toast);
  }

  private static showToast(type: Types, message: string, timeout: number): void {
    if(timeout > 0){
      this.mainToast.setTimeOut(timeout);
    }
    this.mainToast.setType(type);
    this.mainToast.setValue(message);
    this.mainToast.open();
  }
}

export default ToastService;